'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _head2 = require('lodash/head');

var _head3 = _interopRequireDefault(_head2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _utils = require('../utils/');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function accessors(target) {
  target.accessors = (0, _extends3.default)({}, target.accessors, {
    data: function data(_data) {
      return (0, _get3.default)((0, _head3.default)(_data), 'datapoints', []);
    },
    yTicks: function yTicks(base, axis) {
      return axis.yAxis.scale().domain();
    },
    xRange: function xRange(base, axis) {
      return axis.yAxis.scale().rangeExtent();
    },
    annotation: function annotation(options, datum) {
      return utils.getFormat(options.format.datapoint)(datum.x);
    }
  });
}
exports.default = accessors;